import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import * as $ from 'jquery';
import { NgZorroAntdModule, NZ_I18N, en_US } from "ng-zorro-antd";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { TranslateModule, TranslateLoader, MissingTranslationHandler, MissingTranslationHandlerParams } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { GlobalDataStorage } from "./share/storages/global-data.storage";
import { ShareModule } from "@ngx-share/core";
import { TemplateModule } from "./template/template.module";
import { LayoutComponent as Layout2020Component } from "./iwaa/2020/layout/layout.component";
import { LayoutComponent as Layout2021Component } from "./iwaa/2021/layout/layout.component";
import { LayoutComponent as Layout2022Component } from "./iwaa/2022/layout/layout.component";
import { LayoutComponent as Layout2023Component } from "./iwaa/2023/layout/layout.component";
import { LayoutComponent as Layout2024Component } from "./iwaa/2024/layout/layout.component";
import { LayoutComponent as Layout2025Component } from "./iwaa/2025/layout/layout.component";
import { LayoutComponent as Layout2026Component } from "./iwaa/2026/layout/layout.component";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  missingKeyObj = [];

  handle(params: MissingTranslationHandlerParams) {
    if (false) {
      return params.key;
    } else {
      if (this.missingKeyObj.indexOf(params.key) === -1) {
        this.missingKeyObj.push(params.key);
      }
      return `[MISSING-${params.key}]`;
    }
  }
}

@NgModule({
  declarations: [
    AppComponent,
    Layout2020Component,
    Layout2021Component,
    Layout2022Component,
    Layout2023Component,
    Layout2024Component,
    Layout2025Component,
    Layout2026Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgZorroAntdModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ShareModule,
    TemplateModule,
    TranslateModule.forRoot({
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    GlobalDataStorage
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
